import { LegalPage, LegalSection, LegalList } from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      eyebrow="Privacy"
      title="Privacy Policy"
      subtitle="A plain-English explanation of what we collect, why we collect it, and what we won't ever do with it."
      updated="August 6, 2026"
    >
      <LegalSection title="What we collect" testid="privacy-collect">
        <p>
          To run SalesPit and keep matchmaking working, we collect a small
          amount of information:
        </p>
        <LegalList
          items={[
            "Google account information you provide when signing in (name, email address, and profile picture).",
            "Profile information you set inside SalesPit (username, role, and any avatar you upload).",
            "Feedback you submit through the in-app feedback modal (rating, whether you'd use SalesPit again, and any comments).",
            "Session data — timestamps, room names, duration, the peer you were matched with, and any reflection notes you write after a mock call.",
          ]}
        />
      </LegalSection>

      <LegalSection title="How we use it" testid="privacy-use">
        <p>
          We use this information to operate SalesPit and to make it better
          over time. Concretely, that means:
        </p>
        <LegalList
          items={[
            "Signing you in and keeping your session secure.",
            "Matching you with another rep for a live mock call.",
            "Showing you your practice history and reflection notes.",
            "Understanding which features are working and where we can improve — based on aggregated feedback and usage.",
          ]}
        />
      </LegalSection>

      <LegalSection title="What we don't do" testid="privacy-dontsell">
        <p>
          We do not sell your data to third parties. We do not rent it. We do
          not use it for advertising outside SalesPit. Your information is
          used to operate and improve SalesPit — nothing else.
        </p>
      </LegalSection>

      <LegalSection title="Security" testid="privacy-security">
        <p>
          Your data lives in managed infrastructure protected by strict
          access controls. Only authorized SalesPit systems can read the
          tables that hold your data, and every application table is locked
          down at the database level.
        </p>
      </LegalSection>

      <LegalSection title="Questions" testid="privacy-contact">
        <p>
          If you have any question about your privacy on SalesPit, please
          reach out to us at{" "}
          <a
            href="mailto:hello@salespit.io"
            className="text-white underline decoration-[#E52525]/60 decoration-2 underline-offset-4 transition-colors hover:decoration-[#E52525]"
          >
            hello@salespit.io
          </a>
          . We read every message.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
